import { NotificationType } from '@evidentid/tprm-portal-lib/models/notification-configuration';

/**
 * The heading each notification carries on the Email Notifications page.
 *
 * Anything naming a notification to a user reads from here, so a template referenced elsewhere in
 * the product is called the same thing it is called on the page the user is sent to.
 *
 * Three of the labels change wording when the producer flow is on, which is why this takes the
 * flag rather than being a plain map.
 */
export function getNotificationTypeLabel(type: NotificationType, producerFlowEnabled: boolean): string {
    switch (type) {
        case NotificationType.newEntity:
            return 'Entity Notification for Profile & Producer Information';
        case NotificationType.new:
            return producerFlowEnabled
                ? 'Producer Notification for New Requirements'
                : 'Notification for New Requirements';
        case NotificationType.expiring:
            return producerFlowEnabled
                ? 'Producer Notification for Expiring Requirements'
                : 'Notification of Expiring Requirements';
        case NotificationType.nonCompliant:
            return producerFlowEnabled
                ? 'Producer Notification for Non-Compliant Requirements'
                : 'Notification of Non-Compliant Requirements';
        case NotificationType.compliant:
            return 'Notification of Compliant Status';
        default:
            // An unrecognised type is still worth naming — the raw value beats an empty row.
            return type;
    }
}
